export interface ListConductorFilters extends Array<FilterField> {}

export interface FilterField {
  filter: string;
  operator: string;
  value: unknown;
}

export interface ListConductorRawFilter {
  fields: Array<string>;
  operator: string;
  values: Array<string>;
}

export const getRawFilters = (filters: ListConductorFilters) => {
  return filters.map(filter => {
    let filterValue = [filter.value];
    if (Array.isArray(filter.value)) {
      filterValue = filter.value.map(valObj =>
        typeof valObj === 'object'
          ? (valObj as { label: string; value: string }).value.toString()
          : valObj.toString()
      );
    }
    return { operator: filter.operator, values: filterValue, fields: [filter.filter] };
  });
};

export function getRawFilterValuesByKey(filters: ListConductorRawFilter[], key: string) {
  const filter = filters.find(_filter => _filter.fields.includes(key));
  return filter?.values;
}
